var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-none d-xl-flex",attrs:{"id":"lm-breadcrumb"}},[_c('b-breadcrumb',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }